import React from 'react'
import { Link } from "react-router-dom"
import notfound_img from "../Data/sample_images/not_found.png"

const NotFound = () => {
  return (
    <>
    <div className="notfound">
        <div className="container notfound-container">
            <div className="notfound-img-container">
                <img src={notfound_img} alt="not_found" />
            </div>
            <h1 className="notfound-title">Page Not Found</h1>
            <p className="notfound-subtitle">It looks like the page you are looking for does not exist. </p>
            <p className="notfound-subtitle">Are you sure the website URL is correct?</p>
            <Link to="/">
                <button className="btn btn-lg back-to-home">Back To Home</button>
            </Link>
        </div>
    </div>
      
    </>
  )
}

export default NotFound
